class helper {

  // json(str) {
  //   return _.isString(str) ? JSON.parse(str) : JSON.stringify(str)
  // }

  static push(arr, values) {
    arr.push(...values);
    return arr;
  }

  static height(el, value) {
    return _.isNil(value) ? helper.prop(el, "height", value) : _.set(el, "style.height", `${value}px`)
  }

  static prop(item, prop, value) {
    return _.isNil(value) ? _.get(item, prop) : _.set(item, prop, value)
  }

  static on(el, event, fn) {
    if (_.isString(el)) {
      fn = event
      event = el
      el = window
    }
    el.addEventListener(event, _.throttle(fn, 500))
  }

}

export default helper

export {helper}
